import React, { useEffect, useState } from 'react'
import PageLayout from '../../../components/page-layout'
import { Button, Form, Space } from 'antd'
import { useNavigate } from 'react-router'
import { MasterDataForm } from '../components/masterDataForm'
import {
    MasterDataTypeResponse,
    PostMasterDataBody,
} from '../../../model/interface/masterData'
import { MasterDataService } from '../../../service/masterData.service'
import { DataTypeMaster, mapData } from '../typemaster'
import { notificationMessage } from '../../../components/notification'
import ConfirmationModal, {
    ActionType,
} from '../../../components/confirmationModal'

export const CreateMaster = (): JSX.Element => {
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const [data, setData] = useState<DataTypeMaster[] | null>([])

    const onSubmitForm = (formData: PostMasterDataBody) => {
        ConfirmationModal({
            mode: 'create' as ActionType,
            title: 'Master Data',
            onOk: () => {
                try {
                    pushDataCreate(formData)
                } catch (error) {
                    console.error('Error deleting delete:', error)
                }
            },
            okType: 'default',
        })
    }

    const pushDataCreate = async (params: PostMasterDataBody) => {
        try {
            await MasterDataService.postMasterDataItem(params)
            notificationMessage({
                type: 'success',
                message: 'สร้าง Master Data สำเร็จ',
            })
            navigate('/masterdata')
        } catch (error) {
            let errorMessage: string = 'An unexpected error occurred'
            if (
                typeof error === 'object' &&
                error !== null &&
                'error' in error
            ) {
                errorMessage = (error as { error: string }).error
            }
            if (
                errorMessage ===
                'master data item with the same name and type ID already exists'
            ) {
                notificationMessage({
                    type: 'error',
                    message: 'ไม่สามารถสร้าง Master Data ที่ซ้ำกันได้',
                })
            } else {
                notificationMessage({
                    type: 'error',
                    message: 'สร้าง Master Data ไม่สำเร็จ',
                })
            }
        }
    }

    const fetchData = async () => {
        try {
            const responseData: MasterDataTypeResponse =
                await MasterDataService.getAllMasterDataType()
            const mappedData: DataTypeMaster[] | null = mapData(
                responseData.data
            )
            setData(mappedData)
        } catch (error) {
            console.error('Error fetching data:', error)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    return (
        <>
            <PageLayout
                title="สร้าง Master Data"
                action={
                    <Space>
                        <Button
                            type="default"
                            onClick={() =>
                                ConfirmationModal({
                                    mode: 'cancelCreate' as ActionType,
                                    title: 'Master Data',
                                    onOk: () => navigate(-1),
                                    okType: 'default',
                                })
                            }
                        >
                            ยกเลิก
                        </Button>
                        <Button type="primary" onClick={() => form.submit()}>
                            บันทึก
                        </Button>
                    </Space>
                }
            >
                <div>
                    <MasterDataForm
                        form={form}
                        onSubmit={onSubmitForm}
                        data={data}
                    />
                </div>
            </PageLayout>
        </>
    )
}
